import React, {useState} from 'react';
import { connect } from 'react-redux';
import BillingInfo from './components/BillingInfo';
import './Billing.scss';
import BillingEdition from './components/BillingEdition';

const Billing = ({ billing }) => {
  const [flagEdit, setFlagEdit] = useState(Object.entries(billing).length === 0 ? true : false);

  const handleCancel = () => {
    setFlagEdit(false);
  }

  const handleEdit = () => {
    setFlagEdit(true);
  }

  return (
    <>
    <section className="billing-container">
      {!flagEdit ?
        <BillingInfo handleEdit={handleEdit} /> :
        <BillingEdition handleCancel={handleCancel} />
      }
    </section>
    </>
  );
};

const mapStateToProps = (state) => ({
  billing: state.billingReducer.billingData,
});

export default connect(mapStateToProps)(Billing);
